import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Pear.svg",
  "use": "Pear.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Pear.svg\"><path d=\"M32,58A16,16,0,0,1,16,42c0-8.9582,7-12.8345,7-20a9,9,0,0,1,18,0c0,7.1655,7,11.0418,7,20A16,16,0,0,1,32,58Zm2-48a1.6777,1.6777,0,0,1-1.5,1C31.363,11,31,10.4179,31,9c0-3.0217,2.4535-7,5-7,1.4477,0,3,.8828,3,2C39,5.9971,35.8984,6.021,34,10Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol